import React, { Component } from "react";
import { Link } from "react-router-dom";
import Loader from "../component/loader";
import MainLayout from "../mainLayout";
import TextField from "./../component/TextField";

import CopyIcon from "../icons/copyicon";
import UploadFile from "./../component/UploadFile";
import FpgMinusIcon from "../icons/fpgminusicon";
import FpgPlusIcon from "../icons/fpgplusicon";
import TextEditor from "../component/TextEditor";
//Service import
import service from "../services";
import _ from "lodash";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import AddFileIcon from "../icons/plusicon";
//import AWS from "aws-sdk";
import AWS from "aws-sdk";
import moment from "moment-timezone";
import ErrorPopUp from "../component/errorPopUp";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import UploadForm from "../component/fpg/create/UploadForm";
import commonImage from "../commonImage";

let sub;
const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
};

export default class Aboutsundance extends Component {
  constructor(props) {
    super(props);
    const contentState = convertFromRaw(content);
    this.state = {
      getAboutSundanceHeaderTitle: [],
      getAboutSundanceSession: [],
      loaderFlag: false,
      imagePreloader: false,
      editorState: EditorState.createEmpty(),
      sessionArray: [
        {
          _id: Math.random(),
          title: "",
          description: "",
          url: "",
          image: "",
        },
      ],
      contentState,
      data: [
        {
          label: "about sundance page",
          Content: "",
        },
      ],
    };
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        urlValidation: {
          // name the rule
          message: "Please use a valid name of the :attribute",
          rule: (val, params, validator) => {
            return (
              validator.helpers.testRegex(
                val,
                /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              ) && params.indexOf(val) === -1
            );
          },
          required: false, // optional
        },
        websiteValid: {
          // name the rule
          message: "Please use a valid name of the :attribute",
          rule: (val, params, validator) => {
            return (
              validator.helpers.testRegex(
                val,
                /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
              ) && params.indexOf(val) === -1
            );
          },
          required: false, // optional
        },
      },
    });
    this.apiserve = new service();
  }

  componentDidMount = async () => {
    this.getAllAboutSundanceHeaderTitle();
    this.getAboutSundanceEvent();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getAboutSundanceEvent = () => {
    var self = this;
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "aboutSundance|session|getList":
          if (!response.error) {
            var sessionArray =
              response.data &&
              response.data.docs &&
              response.data.docs[0] &&
              response.data.docs[0].sessionArray.map((item) => {
                var session = {
                  _id: Math.random(),
                  image: item.image,
                  title: item.title,
                  description: item.description,
                  url: item.url,
                };
                return session;
              });
              if(sessionArray !== undefined){
              const docs = sessionArray.map((e) => {
              const blocksFromHtml = htmlToDraft(e.description);
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(
                contentBlocks,
                entityMap
              );
              e.description = EditorState.createWithContent(contentState);
              return e;
            });
              }
            this.setState(
              {
                header: response && response.data && response.data.docs[0] && response.data.docs[0].header,
                // sponsordes:sponsordes,
                sessionArray:
                   sessionArray !== undefined 
                    ? sessionArray
                    : //  response.data.docs.filter(
                      //     (item) => (item._id = Math.random())
                      //   )
                      self.state.sessionArray,
              },
              () => {
                this.setState({
                  loaderFlag: false,
                });
              }
            );
            // }
          } else {
            //     var sessionArray = response.data && response.data.docs && response.data.docs[0] && response.data.docs[0].sessionArray.map((image)=>{
            //       var session = {
            //         _id: Math.random(),
            //         image: image.image,
            //         title: image.title,
            //         description: image.description,
            //         url: image.url,
            //       }
            //     return session
            //     })
            //     var obj = {};
            //     const docs = Object.keys(obj).length && sessionArray.map((e) => {
            //         const blocksFromHtml = htmlToDraft(e.description);
            //         const { contentBlocks, entityMap } = blocksFromHtml;
            //         const contentState = ContentState.createFromBlockArray(
            //           contentBlocks,
            //           entityMap
            //         );
            //         e.description = EditorState.createWithContent(contentState);
            //       return e;
            //     });
            //     this.setState(
            //       {
            //         sessionArray,
            //         getAboutSundance:response.data,
            //         HeaderTitle: response && response.data && response.data.docs[0] &&response.data.docs[0].header,
            //         error: response.data.error,
            //       },
            //       () => {
            //         this.setState({
            //           loaderFlag: false,
            //         });
            //       }
            //     );
            //   }
          }
          break;
        case "aboutSundance|session|create":
          if (response.error === true) {
            const blocksFromHtml = htmlToDraft(response.data.description);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(
              contentBlocks,
              entityMap
            );
            const description = description.createWithContent(contentState);
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              description: description,
              errorMsgShow: response.data.error,
            });
          } else {
            this.apiserve.success("About Sundance created successful.");
            this.setState({ loaderFlag: false });
            this.getAllAboutSundanceHeaderTitle()
          }
          break;
        case "aboutSundance|session|getLastUpdated":
          this.setState({
            getLastUpdated: response.data,
          });
          break;
      }
    });
  };

  getAllAboutSundanceHeaderTitle = () => {
    this.apiserve.sendevent("aboutSundance|session|getList", {});
    this.apiserve.sendevent("aboutSundance|session|getLastUpdated", {
      type: 1,
    });
  };

  //Aboutsundance Push
  addAboutsundanceFiled = (item) => {
    var newData = {
      _id: Math.random(),
      image: "",
      title: "",
      description: EditorState.createEmpty(),
      url: "",
    };

    var oldData = this.state.sessionArray;
    oldData.push(newData);

    this.setState({
      sessionArray: oldData,
    });
  };

  //Aboutsundance Remove
  removeAboutsundanceFiled = (i) => {
    var filteredAboutsundance = this.state.sessionArray.filter(
      (_) => _._id !== i
    );
    this.setState({
      sessionArray: filteredAboutsundance,
    });
  };

  onChangeSponsor = (e, id) => {
    const { name, value } = e.target;
    this.state.sessionArray.forEach((dataList) => {
      if (dataList._id === id) {
        dataList.name = value;
      }
    });
    this.setState({});
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      var sessionArray = this.state.sessionArray.map((element) => {
        const name =
          element && element.description
            ? convertToRaw(element && element.description.getCurrentContent())
            : "";
        const markup = draftToHtml(name);

        var List = {
          title: element.title,
          image: element.image,
          url: element.url,
          description: markup.trim(),
        };

        return List;
      });
      this.apiserve.sendevent("aboutSundance|session|create", {
        sessionArray: sessionArray,
        header: this.state.header,
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  onEditorStateChange = (description, id) => {
    this.state.sessionArray.forEach((dataList) => {
      if (dataList._id === id) {
        dataList.description = description;
      }
    });

    this.setState({});
  };

  onChangeFestivalHelp = (e, id) => {
    const { name, value } = e.target;
    this.state.sessionArray.forEach((dataList) => {
      if (dataList._id === id) dataList[name] = value;
    });
    this.setState({});
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  onChangeFile = (e, id) => {
    // e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState(
        {
          file: file,
          // base64: reader.result
        },
        () => {
          const fileList = Math.round(file && file.size / 1024);
          if (fileList >= 3072) {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file smaller than 3 MB",
            });
            return false;
          }
          if (
            (file && file.type === "image/png") ||
            (file && file.type === "image/jpg") ||
            (file && file.type === "image/jpeg")
          ) {
            setTimeout(() => {
              this.imageUpload(file, id,event.target.result);
            }, 0);
          } else {
            this.setState({
              errorMsg: true,
              errorMsgShow: "Please upload a file for PNG,JPG or JPEG",
            });
          }
        }
      );
    };
  };

  imageUpload = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    
    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
      this.setState({
        image: value,
        imagePreloader: false,
      });
      this.state.sessionArray.forEach((image) => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state };
        newState[imagePreloaderId] = false;
        this.setState(newState);
        if (image._id === id) {
          image.image = value;
        }
      });
      this.setState({});
    });
  };

  handelInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  cancelBTN = (e) => {
    e.preventDefault();
    window.location.reload();
    // this.props.history.push({pathaname: '/ticketing'})
}

setDeleteImagePopup = (id) => {
  this.setState({
    deleteImagePopup:true,
    deleteId:id
  })
}
onDeleteImagePopup = () => {
  this.state.sessionArray.forEach(image => {
    if (image._id === this.state.deleteId) {
      image.image = "";
    }
  });
  this.setState({
      deleteImagePopup:false
  })
}
closeAdminUser = () => {
this.setState({  deleteImagePopup:false})
};

  render() {
    const { getLastUpdated } = this.state;
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment.tz(updateAt , 'US/Mountain').format("h");
    var minutes = moment.tz(updateAt, 'US/Mountain').format("mm");
    var state = moment.tz(updateAt, 'US/Mountain').format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
    const { description, sessionArray } = this.state;
    return (
      <React.Fragment>
        <div className="right_side_wrapper artistView_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      <div>{list.label}</div>
                    </p>
                  </li>
                );
              })}
          </ul>
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <p></p>
            {this.state.getLastUpdated &&
            this.state.getLastUpdated.updatedAt === undefined ? (
              ""
            ) : (
              <p className="update_date">
                Last Update: {hour}:{minutes} {state} -{" "}
                {moment.tz(updateAt, 'US/Mountain').format("MM/DD/YYYY")} Last Updated By:{" "}
                {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}
              </p>
            )}
          </div>

          <div className="fpg_tabcontent about_sundance">
            <form>
              <div className="field_row horizontal_field">
                <TextField
                  type="text"
                  label="Header Title"
                  name="header"
                  value={this.state.header}
                  onChange={this.handelInput}
                />
              </div>
              {sessionArray &&
                sessionArray?.map((item, i) => {
                  const imagePreloaderState = `imagePreloader_${item._id}`;
                  return (
                    <div className="section_box_wrapper">
                      <div className="d_flex d_flex_align_center">
                        <div className="section_box">
                          <div className="header">
                            <p>Section {i+1}</p>
                          </div>
                          <div className="section_content">
                            <div className="d_flex">
                              <div className="section_fields">
                                <div className="field_row horizontal_field">
                                  <TextField
                                    type="text"
                                    label="Header Title"
                                    name="title"
                                    onChange={(e) =>
                                      this.onChangeFestivalHelp(e, item._id)
                                    }
                                    id={item._id}
                                    value={item.title}
                                  />
                                </div>
                                <div className="field_heading field_row horizontal_field">
                                  <div className="field_row_inner">
                                    <label className="fest_field_title">
                                      Paragraph
                                    </label>
                                    <div className="field_input relative editor_wrapper">
                                      {/* <div className="heading_bg"> </div> */}
                                      <div className="">
                                        <TextEditor
                                         
                                          name="description"
                                          editorState={item.description}
                                          value={item.description}
                                          onEditorStateChange={(e) =>
                                            this.onEditorStateChange(
                                              e,
                                              item._id
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="section_media ">
                                <div className="relative">
                                  <div className="uploads_files absolute_loader">
                                    <span className="upload_message">Upload PNG/JPEG of max size of 3MB</span>
                                    {this.state[imagePreloaderState] ? (
                                      <Loader />
                                    ) : (
                                      <>
                                      <img
                                        src={
                                          item.image
                                            ? this.apiserve.imageUrl +
                                              item.image
                                            : item.url
                                            ? item.url
                                            : "./images/image-placeholder.png"
                                        }
                                        alt="image"
                                      />
                                      </>
                                    )}

                                    <UploadForm
                                      item={item}
                                      handleImage={(e) =>
                                        this.onChangeFile(e, item._id)
                                      }
                                      iconDelete={true}
                                      deleteImage={()=>this.setDeleteImagePopup(item._id)}
                                      
                                    />
                                  </div>
                                </div>
                                <div className="field_row">
                                  <div className="field_input relative">
                                    <input
                                      type="text"
                                      placeholder="https://cloudfront.aws.com/sdf2345"
                                      name="url"
                                      onChange={(e) =>
                                        this.onChangeFestivalHelp(e, item._id)
                                      }
                                      id={item._id}
                                      defaultValue={item.url}
                                    />
                                    <span className="copy_box">
                                      <CopyIcon />
                                    </span>
                                  </div>
                                </div>
                                {i === 0 ? (
                                  <span style={{ color: "red" }}>
                                    {this.validator.message(
                                      "image or link",
                                      item.url || item.image,
                                      "required|urlValidation"
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="section_actions">
                          {i === 0 ? (
                            <span
                              className="pointer"
                              onClick={() =>
                                this.addAboutsundanceFiled(item, i)
                              }
                            >
                              <FpgPlusIcon
                                width="20"
                                height="20"
                                color="#4F4F4F"
                                stroke="#fff"
                              />
                            </span>
                          ) : (
                            <>
                              <span
                                className="pointer"
                                onClick={() =>
                                  this.addAboutsundanceFiled(item, i)
                                }
                              >
                                <FpgPlusIcon
                                  width="20"
                                  height="20"
                                  color="#4F4F4F"
                                  stroke="#fff"
                                />
                              </span>
                              <span
                                className="pointer"
                                onClick={() =>
                                  this.removeAboutsundanceFiled(item._id)
                                }
                              >
                                <FpgMinusIcon
                                  width="20"
                                  height="20"
                                  color="#4F4F4F"
                                  stroke="#fff"
                                />
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              <div className="text_center field_row w_100 buttons_outer mb_0">
                <button className="uppercase" onClick={this.cancelBTN}>CANCEL</button>
                <button
                  className="uppercase active"
                  type="button"
                  onClick={(e) => this.submitFn(e)}
                >
                  SAVE
                </button>
              </div>
            </form>
          </div>
        </div>
        {this.state.errorMsg ? (
          <ErrorPopUp
            errorMsg={this.state.errorMsgShow}
            errorMsgPopup={this.validateModel}
          />
        ) : (
          ""
        )}
        {/* <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div> */}
        {this.state.loaderFlag ? <Loader /> : ""}
        {this.state.deleteImagePopup
				? <PopUpCustomAll
					HeaderName="Delete Image?"
					insideDetails="Are You Sure ?"
					insideData="You want to delete this image"
					popupState={() => this.closeAdminUser()}
					yesPopUp={() => this.onDeleteImagePopup()} />
				: ""
			}
      </React.Fragment>
    );
  }
}
